var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["loyalty-success.j2"] = require( "loyalty-success.j2" );
dependencies["loyalty-member.j2"] = require( "loyalty-member.j2" );
dependencies["loyalty-form.j2"] = require( "loyalty-form.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-signup.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"";
if(runtime.contextOrFrameLookup(context, frame, "loyaltyModal")) {
output += " dom-loyalty-modal ";
;
}
else {
output += " dom-loyalty-page ";
;
}
output += " c-loyalty\" data-qa-loyalty-form>\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"viewReady")) {
output += "\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"signupSuccess")) {
output += "\n            ";
env.getTemplate("loyalty-success.j2", false, "loyalty/templates/loyalty-signup.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n        ";
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"profile") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"profile")),"loyalty") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"profile")),"loyalty")),"loyaltyId")) {
output += "\n            ";
env.getTemplate("loyalty-member.j2", false, "loyalty/templates/loyalty-signup.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n        ";
})});
}
else {
output += "\n            ";
env.getTemplate("loyalty-form.j2", false, "loyalty/templates/loyalty-signup.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n        ";
})});
}
;
}
output += "\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-signup.j2"] , dependencies)